

















import { Component, Vue } from 'vue-property-decorator'
import UnitList from '@/components/UnitList.vue'

@Component({
  components: {
    UnitList
  }
})
export default class Unit extends Vue {}
